import React, { ReactNode, useEffect } from 'react';
import { useLanguage } from '../hooks/useLanguage';

interface LanguageGateProps {
  children: ReactNode;
}

/**
 * LanguageGate handles the initialization and synchronization of the user's language.
 * It also updates the document's lang and dir attributes.
 */
export const LanguageGate: React.FC<LanguageGateProps> = ({ children }) => {
  const { language } = useLanguage();

  useEffect(() => {
    if (language) {
      document.documentElement.lang = language;
      // Handle RTL if needed in the future (e.g., Arabic 'ar')
      // For now, all supported languages are LTR
      document.documentElement.dir = 'ltr';
    }
  }, [language]);

  return <>{children}</>;
};
